import {Injectable} from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from "../services/auth.service";
import {CookieXAuthToken} from "../constants/auth-dictionary.enum";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const xAuthToken = this.authService.getToken();
    return !!xAuthToken ?
      next.handle(request.clone({setHeaders: {[CookieXAuthToken]: xAuthToken}})) : next.handle(request);
  }
}
